/* eslint-disable */
import { manageFormActionTypes } from "../actions/actionTypes";

let initialState = {};
const manageFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case manageFormActionTypes.SET_EDIT_FORM:
      return action.payload;
    default:
      return state;
  }
};
export default manageFormReducer;
